import http from '@/http'

export async function getPart (id: Number): Promise<any> {
  const { data } = await http.get(`/admin/parts/${id}`)
  return data
}
